import React, { useEffect } from 'react';
import { Heading } from '@podiumhq/design-system';

import FullScreenSpinner from 'components/LoadingElements/FullScreenSpinner';
import useChangePage from 'hooks/useChangePage';
import { TRIAL_URL } from 'routes/constants';

const LOADING_INTERVAL = 1500;

const FakeCreatingAccountLoading = () => {
  const changePage = useChangePage();

  useEffect(() => {
    const timer = setInterval(() => {
      changePage(`${TRIAL_URL}/profile`);
    }, LOADING_INTERVAL);

    return () => clearInterval(timer);
  }, [changePage]);

  return (
    <FullScreenSpinner
      backgroundColor="black.base"
      direction="column"
      spinnerProps={{ color: 'black.lightest', size: 'lg' }}
    >
      <Heading
        color="silver.lightest"
        fontSize="2xl"
        fontWeight="medium"
        margin="24px"
        textAlign="center"
      >
        Perfect, we’re creating your Podium account.
      </Heading>
    </FullScreenSpinner>
  );
};

export default FakeCreatingAccountLoading;
